import React from 'react'
import styles from './styles.module.css' // Ensure this is the correct path to your CSS module
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg' // adjust path if needed

function MostRecentPriceDate ({
  mostRecentPriceDateFilter,
  setMostRecentPriceDateFilter
}) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartDateChange = e => {
    setMostRecentPriceDateFilter({
      ...mostRecentPriceDateFilter,
      startDate: e.target.value
    })
  }

  const handleEndDateChange = e => {
    setMostRecentPriceDateFilter({
      ...mostRecentPriceDateFilter,
      endDate: e.target.value
    })
  }

  return (
    <div className={styles.RecentStatusDateContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.RecentStatusDateTitle}>
          Most recent for sale list price date
        </h1>
        <Tooltip
          title="Filter by the date when a property’s most recent for-sale list price was recorded. Set a start and/or end date to narrow results."
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '10px 14px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Most recent list price date info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.RecentStatusDateInputContainer}>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='startDate'
          max={maxDate}
          value={mostRecentPriceDateFilter.startDate}
          onChange={handleStartDateChange}
          required
        />
        <span className={styles.RecentStatusDateLabel}>to</span>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='endDate'
          max={maxDate}
          value={mostRecentPriceDateFilter.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>
    </div>
  )
}

export default MostRecentPriceDate
